import PropTypes from 'prop-types';
import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var FILTERS_OFF = {
	elements: [
		{
			tag: "path",
			fill: "#3D3F42",
			d: "M4.7,6.5h14.6c0.4,0,0.7,0.3,0.7,0.7v1.6c0,0.4-0.3,0.7-0.7,0.7H4.7C4.3,9.5,4,9.2,4,8.8V7.2 C4,6.8,4.3,6.5,4.7,6.5z"
		},
		{
			tag: "path",
			fill: "#3D3F42",
			d: "M7.4,12.5h9.3c0.4,0,0.7,0.3,0.7,0.7v1.6c0,0.4-0.3,0.7-0.7,0.7H7.4 c-0.4,0-0.7-0.3-0.7-0.7v-1.6C6.7,12.8,7,12.5,7.4,12.5z"
		},
		{
			tag: "path",
			fill: "#3D3F42",
			d: "M10,18.5H14c0.4,0,0.7,0.3,0.7,0.7v1.6c0,0.4-0.3,0.7-0.7,0.7H10c-0.4,0-0.7-0.3-0.7-0.7v-1.6 C9.3,18.8,9.6,18.5,10,18.5z"
		}
	],
	"data-icon": "filters-off",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24"
};
var FILTERS_ON = {
	elements: [
		{
			tag: "path",
			fill: "#3D3F42",
			d: "M4.7,6.5h14.6c0.4,0,0.7,0.3,0.7,0.7v1.6c0,0.4-0.3,0.7-0.7,0.7H4.7C4.3,9.5,4,9.2,4,8.8V7.2 C4,6.8,4.3,6.5,4.7,6.5z"
		},
		{
			tag: "path",
			fill: "#3D3F42",
			d: "M7.4,12.5h9.3c0.4,0,0.7,0.3,0.7,0.7v1.6c0,0.4-0.3,0.7-0.7,0.7H7.4 c-0.4,0-0.7-0.3-0.7-0.7v-1.6C6.7,12.8,7,12.5,7.4,12.5z"
		},
		{
			tag: "path",
			fill: "#3D3F42",
			d: "M10,18.5H14c0.4,0,0.7,0.3,0.7,0.7v1.6c0,0.4-0.3,0.7-0.7,0.7H10c-0.4,0-0.7-0.3-0.7-0.7v-1.6 C9.3,18.8,9.6,18.5,10,18.5z"
		},
		{
			tag: "circle",
			fill: "#3E75CF",
			stroke: "#fff",
			strokeWidth: "2",
			cx: "18",
			cy: "5.5",
			r: "5"
		}
	],
	"data-icon": "filters-on",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24"
};
var DASHBOARD = {
	elements: [
		{
			tag: "path",
			fill: "#3D3F42",
			d: "m2,0l12,0c1.10457,0 2,0.89543 2,2l0,12c0,1.10457 -0.89543,2 -2,2l-12,0c-1.10457,0 -2,-0.89543 -2,-2l0,-12c0,-1.10457 0.89543,-2 2,-2zm9,9c-0.55228,0 -1,0.44772 -1,1l0,3c0,0.55228 0.44772,1 1,1l2,0c0.55228,0 1,-0.44772 1,-1l0,-3c0,-0.55228 -0.44772,-1 -1,-1l-2,0zm0,-7c-0.55228,0 -1,0.44772 -1,1l0,3c0,0.55228 0.44772,1 1,1l2,0c0.55228,0 1,-0.44772 1,-1l0,-3c0,-0.55228 -0.44772,-1 -1,-1l-2,0zm-8,0c-0.55228,0 -1,0.44772 -1,1l0,10c0,0.55228 0.44772,1 1,1l4,0c0.55228,0 1,-0.44772 1,-1l0,-10c0,-0.55228 -0.44772,-1 -1,-1l-4,0z"
		}
	],
	"data-icon": "dashboard",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16"
};
var GOOGLE_CLASSROOM = {
	elements: [
		{
			tag: "path",
			fill: "#000000",
			d: "M 5 2 C 3.347656 2 2 3.347656 2 5 L 2 19 C 2 20.652344 3.347656 22 5 22 L 19 22 C 20.652344 22 22 20.652344 22 19 L 22 5 C 22 3.347656 20.652344 2 19 2 Z M 5 4 L 19 4 C 19.550781 4 20 4.449219 20 5 L 20 19 C 20 19.550781 19.550781 20 19 20 L 18 20 L 18 18 L 13 18 L 13 20 L 5 20 C 4.449219 20 4 19.550781 4 19 L 4 5 C 4 4.449219 4.449219 4 5 4 Z M 12 6 C 10.894531 6 10 6.894531 10 8 C 10 9.105469 10.894531 10 12 10 C 13.105469 10 14 9.105469 14 8 C 14 6.894531 13.105469 6 12 6 Z M 7.5 8 C 6.671875 8 6 8.671875 6 9.5 C 6 10.328125 6.671875 11 7.5 11 C 8.328125 11 9 10.328125 9 9.5 C 9 8.671875 8.328125 8 7.5 8 Z M 16.5 8 C 15.671875 8 15 8.671875 15 9.5 C 15 10.328125 15.671875 11 16.5 11 C 17.328125 11 18 10.328125 18 9.5 C 18 8.671875 17.328125 8 16.5 8 Z M 12 11 C 9.339844 11 8.5 13.5 8.5 13.5 C 8.5 12.652344 9 12 9 12 C 8.699219 11.8125 7.929688 11.6875 7.5625 11.6875 C 6.347656 11.6875 5 12.878906 5 13.6875 L 5 16 L 19 16 L 19 13.6875 C 19 12.878906 17.488281 11.6875 16.4375 11.6875 C 16.070313 11.6875 15.300781 11.8125 15 12 C 15 12 15.5 12.652344 15.5 13.5 C 15.5 13.5 14.660156 11 12 11 Z"
		}
	],
	"data-icon": "google-classroom",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24"
};
var iconJSON = {
	FILTERS_OFF: FILTERS_OFF,
	FILTERS_ON: FILTERS_ON,
	DASHBOARD: DASHBOARD,
	GOOGLE_CLASSROOM: GOOGLE_CLASSROOM
};

var _excluded = ["title", "elements"],
    _excluded2 = ["tag"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Icon = function Icon(_ref) {
  var title = _ref.title,
      elements = _ref.elements,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsxs("svg", _objectSpread(_objectSpread({
    role: "img",
    focusable: "false",
    "aria-hidden": "true"
  }, rest), {}, {
    children: [/*#__PURE__*/jsx("title", {
      children: title
    }), elements.map(Icon.renderElement)]
  }));
};

Icon.renderElement = function (_ref2, index) {
  var TagName = _ref2.tag,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/jsx(TagName, _objectSpread({}, rest), "".concat(TagName, "-").concat(index));
};

Icon.ICONS = iconJSON;
Icon.propTypes = {
  elements: PropTypes.arrayOf(PropTypes.shape({
    tag: PropTypes.string.isRequired,
    d: PropTypes.string,
    fill: PropTypes.string
  })).isRequired,
  title: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  viewBox: PropTypes.string
};
Icon.defaultProps = {
  height: 24,
  width: 24,
  title: "",
  viewBox: "0 0 24 24"
};

export { Icon as default };
//# sourceMappingURL=icon-esm.js.map
